import { LayoutHOC } from 'base/ui/layout/layout';
import { createSynchPurchaseOrder } from '.';

export const createSynchPurchaseOrderPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createSynchPurchaseOrder());
};
